import React from "react";
import {Link} from "react-router-dom";
import Card from "../../../common/components/card";

export default function NotFound({user = {}, translate, backLink, backBtnLabel}) {
    return (
        <div className="h-full flex items-center justify-center">
            <Card
                className="bg-inverse rounded-lg border-tm-gray-200 shadow-card z-10 overflow-hidden z-10 mx-6"
                bodyClass="lg:grid grid-cols-10 max-w-4xl"
            >
                <div className="image-auth relative py-10 sm:py-20 px-10 col-span-4">
                    <p className=" text-white h2">MAGIC IS IN THE DETAILS</p>

                    <p className="white mb-0">
                        Placeholder text
                    </p>

                    {!!user.register && (
                        <React.Fragment>
                            <p>
                                <div>{translate('text.register_success')}</div>
                                <Link to={`/login`}>{translate('btn.back_to_login')}</Link>
                            </p>
                        </React.Fragment>
                    )}
                </div>
                <div className="p-10 lg:p-20 col-span-6">
                    <Link to={`/`}>
                        <span className="logo-single"></span>
                    </Link>

                    <h6
                        className="mb-8 text-tm-gray-700 text-base text-base">{translate('page.404.heading_main')}</h6>

                    <p className="mb-2 text-tm-gray-700 text-sm">
                        <span>{translate('page.404.code')}</span>
                    </p>

                    <p className="text-8xl font-bold text-primary-shade mb-7">{translate('page.404.body')}</p>

                    <div className="flex">
                        <Link
                            className="btn btn-primary text-sm hover:text-white"
                            to={backLink ?? `/home`}
                        >
                            {
                                backBtnLabel ?? translate('btn.back_to_home')
                            }
                        </Link>
                    </div>

                </div>
            </Card>
        </div>
    )
}